import { useEffect } from 'react';
import { useWindowSize } from 'usehooks-ts';
import { useLocation } from 'react-router-dom';

export const useLoggerHook = () => {
  const location = useLocation();
  const windowSize = useWindowSize();

  const { search, pathname } = location;

  useEffect(() => {
    const getSanitizedSearch = (value: string): string => {
      if (!value) return value;

      const params = new URLSearchParams(value);
      if (params.has('authCode')) {
        params.set('authCode', 'REDACTED');
      }
      if (params.has('state')) {
        params.set('state', 'REDACTED');
      }

      const next = params.toString();
      return next ? `?${next}` : '';
    };

    console.log('location changed to', pathname + getSanitizedSearch(search));
  }, [search, pathname]);

  useEffect(() => {
    console.log('window size changed to', windowSize);
  }, [windowSize]);
};
